import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Bespokeuk() {
  return (
    <section className="bespoke_uk p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-2 order-md-1 mt-3 mt-md-0"
          >
            <StaticImage
              src="../../../images/location_new/uk-web/uk-bespoke-web.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={750}
              height={468}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-1 order-md-2"
          >
            <h2>
              Hire A Bespoke <span>Web Development Company</span> in UK For Your
              Next Project
            </h2>
            <p>
              As an impactful web development company in UK, TekRevol’s success
              lies behind the expertise of its professional team of developers
              that crafts such websites that revolutionize the growth of
              businesses. Considering the escalating demands of the users, your
              website must come out as the right solution to their solutions.
              That’s where our website developers in UK shine as they have
              enough experience to analyze the current trend of the market. As a
              result, we always build something unique as a team that creates a
              difference in the relevant industry of the client's business.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Bespokeuk;
